import clsx from "clsx";
import About from "./About";
import { fetchTokenDetail } from "~/api/endpoints";
import useSWR from "swr";

export default function ({ chain_id, contract, className = "" }: any) {
    const initData = (args: any) => {
        const [_, chain_id, contract] = args;
        return fetchTokenDetail(chain_id, contract).then(
            (res) => res?.data?.information || {}
        );
    };

    const { data: info } = useSWR(
        ["k-detail:apiTokenDetail", chain_id, contract],
        initData,
        {
            fallbackData: {},
        }
    );

    return (
        <div className={clsx("px-[16px]", className)}>
            <About info={info} contract={contract} />
        </div>
    );
}
